/**
 * @generated SignedSource<<f138b43130a634011debbce19a5568aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "serviceId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "serviceId",
        "variableName": "serviceId"
      }
    ],
    "concreteType": "Service",
    "kind": "LinkedField",
    "name": "ToggleServiceFavorite",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rowId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isUserFavorite",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ServiceDetailSectionMutation",
    "selections": (v1/*: any*/),
    "type": "ClientAppMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ServiceDetailSectionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8b9a25421b40c91243119579aba13bcc",
    "id": null,
    "metadata": {},
    "name": "ServiceDetailSectionMutation",
    "operationKind": "mutation",
    "text": "mutation ServiceDetailSectionMutation(\n  $serviceId: Int!\n) {\n  ToggleServiceFavorite(serviceId: $serviceId) {\n    id\n    rowId\n    name\n    isUserFavorite\n  }\n}\n"
  }
};
})();

node.hash = "a5aa3543bc5c770d38af25dccd1e33bd";

module.exports = node;
